<template>
  <div class="project-modal generic-modal"
       :class="classes">
    <div class="project-modal__background"
         @click="$emit('close')"></div>
    <div class="project-modal__inner">
      <div class="project-modal__close"
           @click="$emit('close')">X
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>

/**
 * Generic modal for displaying a message to a user.
 */
export default {
  name: 'GenericModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: ''
    }
  },
}
</script>

<style scoped lang="scss">

</style>
